<template>
  <div v-if="isOfferAvailable">
    <div v-if="isCommissionaire">
      <div v-if="isSigningAvailble">
        <signing-modal />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useComparatorStore, useProjectStore } from '@/stores';
import SigningModal from '@/components/modals/SigningModal.vue';

export default {
  name: 'actions',
  components: {
    SigningModal,
  },
  computed: {
    ...mapState(useComparatorStore, ['offer']),
    ...mapState(useProjectStore, ['projectSelected']),
    isOfferAvailable() {
      return !!(this.offer && Object.keys(this.offer).length);
    },
    isSigningAvailble() {
      return !!(this.offer.signing_procedure
        && Object.keys(this.offer.signing_procedure).length);
    },
    isCommissionaire() {
      return !!this.projectSelected.params.is_commissionaire;
    },
  },
};
</script>
